module.exports = __webpack_public_path__ + "static/img/ex_title.d57b80db.jpg";